import { render } from "./OtherVoucher.vue?vue&type=template&id=28a87ab4&scoped=true&ts=true"
import script from "./OtherVoucher.vue?vue&type=script&lang=ts"
export * from "./OtherVoucher.vue?vue&type=script&lang=ts"

import "./OtherVoucher.vue?vue&type=style&index=0&id=28a87ab4&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a87ab4"]])

export default __exports__